import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Button from '@material-ui/core/Button';
import FabWithText from '../../../components/FabWithText/FabWithText';
import BaseDialog from '../../../components/BaseDialog/BaseDialog';
import ReplaceContact from '../../../components/Replace/ReplaceContact/ReplaceContact';
import ButtonRadioField from '../../../components/Fields/ButtonRadioField/ButtonRadioField';
import ActionLink from '../../../components/ActionLink/ActionLink';
import NewWorkRequestDialog from './NewWorkRequestDialog/NewWorkRequestDialog';
import ContactDetailsForm from './ContactDetailsForm/ContactDetailsForm';
import BuildIcon from '@material-ui/icons/BuildOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ReportProblemIcon from '@material-ui/icons/ReportProblemOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import { getString } from '../../../helpers/stringHelpers.js';
import { isFeatureDisabled } from '../../../helpers/outageHelpers';
import { isMobile } from 'react-device-detect';
import Link from '../../../components/Link/Link.js';

const stringsComponent = 'workRequests';
class NewWorkRequestButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: null,
      dialogCovidInfoOpen: false,
      initialDialogData: {
        mobilePhone: '',
        mobilePhoneName: '',
        mobilePhoneId: '',
        preferredPhone: '',
        preferredPhoneName: '',
        preferredPhoneId: '',
        email: '',
        emailId: '',
      },
      covidSymptoms: '',
      updatedDialogData: null,
    };

    this.initialState = this.state;

    this.handleToggleDialog = this.handleToggleDialog.bind(this);
    this.handleToggleDialogCovidInfo =
      this.handleToggleDialogCovidInfo.bind(this);
    this.handleContactFormUpdate = this.handleContactFormUpdate.bind(this);
    this.handleContactDialogSubmit = this.handleContactDialogSubmit.bind(this);
    this.setDialogValues = this.setDialogValues.bind(this);
    this.generateDialogContent = this.generateDialogContent.bind(this);
  }

  handleToggleDialog(dialog = null) {
    this.setState({
      dialogOpen: dialog,
    });
  }

  handleToggleDialogCovidInfo() {
    const { dialogCovidInfoOpen } = this.state;
    this.setState({
      dialogCovidInfoOpen: !dialogCovidInfoOpen,
    });
  }

  handleCovidQuestionChange(event, key, nextAction) {
    const { setCustomerIsolating } = this.props;

    const value = event.target.value;
    this.setState({ [key]: value });

    let isolating;
    if (value === 'no') {
      isolating = false;
    } else if (value === 'yes') {
      isolating = true;
    }
    setCustomerIsolating(isolating);
  }

  handleContactFormUpdate(submitDialogData) {
    this.setState(
      {
        updatedDialogData: submitDialogData,
      },
      this.handleToggleDialog('three')
    );
  }

  handleContactDialogSubmit() {
    const { updateContact, action } = this.props;
    const { initialDialogData, updatedDialogData } = this.state;

    if (!this.checkWritesDisabled()) {
      const contacts = [
        updatedDialogData.mobilePhone != initialDialogData.mobilePhone ||
        updatedDialogData.mobilePhoneName != initialDialogData.mobilePhoneName
          ? {
              contactName: updatedDialogData.mobilePhoneName,
              value: updatedDialogData.mobilePhone,
              type: 'mobilePhone',
              id: updatedDialogData.mobilePhoneId,
            }
          : null,
        updatedDialogData.preferredPhone != initialDialogData.preferredPhone ||
        updatedDialogData.preferredPhoneName !=
          initialDialogData.preferredPhoneName
          ? {
              contactName: updatedDialogData.preferredPhoneName,
              value: updatedDialogData.preferredPhone,
              type: 'preferredPhone',
              id: updatedDialogData.preferredPhoneId,
            }
          : null,
        updatedDialogData.email != initialDialogData.email
          ? {
              contactName: 'Email',
              value: updatedDialogData.email,
              type: 'email',
              id: updatedDialogData.emailId,
            }
          : null,
        null,
        null,
      ];

      updateContact('1', contacts);
    }

    action();
  }

  setDialogValues() {
    const { contactData } = this.props;

    this.setState({
      initialDialogData: {
        preferredPhone: contactData.preferredPhone,
        preferredPhoneName: contactData.preferredPhoneName,
        preferredPhoneId: contactData.preferredPhoneId,
        mobilePhone: contactData.mobilePhone,
        mobilePhoneName: contactData.mobilePhoneName,
        mobilePhoneId: contactData.mobilePhoneId,
        email: contactData.email,
        emailId: contactData.emailId,
      },
    });
  }

  generateDialogContent() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.sectionWithIcon}>
          <ReportProblemIcon className={classes.sectionIcon} />
          <div>
            <Typography variant="h3" className={classes.dialogTitle}>
              {getString(
                stringsComponent,
                'NEW_REQUEST_DIALOG_EMERGENCY_TITLE'
              )}
            </Typography>
            <Typography variant="body2" className={classes.dialogText}>
              {getString(
                stringsComponent,
                'NEW_REQUEST_DIALOG_EMERGENCY_TEXT_PART_1'
              )}{' '}
              {isMobile && <Link label="111" link="tel:111" />}
              {!isMobile && '111'}{' '}
              {getString(
                stringsComponent,
                'NEW_REQUEST_DIALOG_EMERGENCY_TEXT_PART_2'
              )}
            </Typography>
          </div>
        </div>
        <Divider className={classes.dialogDivider1} />
        <div className={classes.sectionWithIcon}>
          <ErrorIcon className={classes.sectionIcon} />
          <div>
            <Typography variant="h3" className={classes.dialogTitle}>
              {getString(stringsComponent, 'NEW_REQUEST_DIALOG_URGENT_TITLE')}
            </Typography>
            <Typography variant="body2" className={classes.dialogText}>
              {getString(stringsComponent, 'NEW_REQUEST_DIALOG_URGENT_TEXT')}
            </Typography>
          </div>
        </div>
        <Divider className={classes.dialogDivider1} />
        <ExpansionPanel className={classes.dialogExpansionPanel}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography variant="body2" className={classes.examples}>
              {getString(
                stringsComponent,
                'NEW_REQUEST_DIALOG_URGENT_EXAMPLE_INTRO'
              )}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <List className={classes.dialogList}>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="body2">
                      {getString(
                        stringsComponent,
                        'NEW_REQUEST_DIALOG_URGENT_EXAMPLE_1'
                      )}
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="body2">
                      {getString(
                        stringsComponent,
                        'NEW_REQUEST_DIALOG_URGENT_EXAMPLE_2'
                      )}
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="body2">
                      {getString(
                        stringsComponent,
                        'NEW_REQUEST_DIALOG_URGENT_EXAMPLE_3'
                      )}
                    </Typography>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary={
                    <Typography variant="body2">
                      {getString(
                        stringsComponent,
                        'NEW_REQUEST_DIALOG_URGENT_EXAMPLE_4'
                      )}
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <Divider className={classes.dialogDivider2} />
        <Typography variant="body2" className={classes.dialogText}>
          {getString(stringsComponent, 'NEW_REQUEST_DIALOG_EMERGENCY')}
        </Typography>
      </React.Fragment>
    );
  }

  checkWritesDisabled() {
    const { contactData } = this.props;

    return contactData.updating || isFeatureDisabled('PROFILE_WRITE');
  }

  getCommonDialogProps(dialogTitle) {
    return {
      title: dialogTitle,
      largeTitle: true,
      buttonLabel: getString('app', 'MAINTENANCE_NEXT_LABEL'),
      secondaryButtonLabel: getString('app', 'MAINTENANCE_CANCEL_LABEL'),
      supplementaryButtonLabel: getString('app', 'MAINTENANCE_BACK_LABEL'),
      secondaryButtonAction: this.handleToggleDialog,
      inlineTitle: true,
      contentWrap: false,
      icon: BuildIcon,
    };
  }

  render() {
    const {
      classes,
      contactData,
      contactAction,
      gaEvent,
      currentRequestsAction,
      limitReached,
      limitReached2,
    } = this.props;

    const { dialogOpen, dialogCovidInfoOpen, covidSymptoms } = this.state;

    const dialogTitle = getString(stringsComponent, 'NEW_REQUEST_DIALOG_TITLE');

    const writesDisabled = this.checkWritesDisabled();

    const commonDialogProps = this.getCommonDialogProps(dialogTitle);

    const covidInfoLink = (
      <Typography className={classes.bottomDialogText}>
        <ActionLink
          label={getString(
            stringsComponent,
            'NEW_REQUEST_DIALOG_COVID_INFO_LINK'
          )}
          action={this.handleToggleDialogCovidInfo}
        />
      </Typography>
    );

    return (
      <div className={classes.root}>
        <NewWorkRequestDialog
          open={dialogOpen === 'one'}
          action={() => {
            this.setDialogValues();
            this.handleToggleDialog('two');
          }}
          secondaryAction={this.handleToggleDialog}
          disableNext={false}
          title={dialogTitle}
          content={this.generateDialogContent()}
        />
        <ContactDetailsForm
          {...commonDialogProps}
          open={dialogOpen === 'two'}
          content={
            <React.Fragment>
              <Typography variant="h3" className={classes.dialogTitle}>
                {getString(
                  stringsComponent,
                  'NEW_REQUEST_DIALOG_CONTACT_TITLE'
                )}
              </Typography>
              <Typography variant="body2" className={classes.dialogText}>
                {getString('app', 'MAINTENANCE_ENGLISH_ONLY_TEXT')}
              </Typography>
              <Typography variant="body2" className={classes.dialogText}>
                {writesDisabled ? (
                  <ReplaceContact
                    content={getString(
                      stringsComponent,
                      'NEW_REQUEST_DIALOG_CONTACT_DISABLED_TEXT'
                    )}
                    action={contactAction}
                    forceEnglish={true}
                    isLink={true}
                  />
                ) : (
                  getString(stringsComponent, 'NEW_REQUEST_DIALOG_CONTACT_TEXT')
                )}
              </Typography>
            </React.Fragment>
          }
          initialDialogData={contactData}
          buttonAction={this.handleContactFormUpdate}
          supplementaryButtonAction={() => {
            this.handleToggleDialog('one');
          }}
          readOnly={writesDisabled}
        />
        <BaseDialog
          {...commonDialogProps}
          open={dialogOpen === 'three'}
          content={
            <div className={classes.dialogContent}>
              <Typography variant="h3" className={classes.dialogTitle}>
                {getString(
                  stringsComponent,
                  'NEW_REQUEST_DIALOG_BEFORE_STARTING_TITLE'
                )}
              </Typography>
              <Typography variant="body2" className={classes.dialogText}>
                {getString(
                  stringsComponent,
                  'NEW_REQUEST_DIALOG_BEFORE_STARTING_TEXT'
                )}
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                className={`${classes.dialogText} ${classes.dialogButton}`}
                onClick={currentRequestsAction}
              >
                {getString(
                  stringsComponent,
                  'NEW_REQUEST_DIALOG_CURRENT_JOBS_BUTTON'
                )}
              </Button>
            </div>
          }
          buttonAction={() => {
            this.handleContactDialogSubmit();
          }}
          supplementaryButtonAction={() => {
            this.handleToggleDialog('two');
          }}
        />
        {limitReached ? (
          <React.Fragment>
            <Typography variant="body2" className={classes.body}>
              {limitReached}
            </Typography>
            <Typography variant="body2" className={classes.body}>
              {limitReached2}
            </Typography>
          </React.Fragment>
        ) : (
          <FabWithText
            filled={true}
            label={getString(stringsComponent, 'NEW_REQUEST_LABEL')}
            icon={AddIcon}
            action={() => {
              this.handleToggleDialog('one');
              gaEvent();
            }}
            ariaLabel="Create"
          />
        )}
      </div>
    );
  }
}

NewWorkRequestButton.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]).isRequired,
  action: PropTypes.func,
  limitReached: PropTypes.string,
  limitReached2: PropTypes.object,
  gaEvent: PropTypes.func.isRequired,
  currentRequestsAction: PropTypes.func.isRequired,
  contactAction: PropTypes.func.isRequired,
  setCustomerIsolating: PropTypes.func.isRequired,
};

NewWorkRequestButton.defaultProps = {
  limitReached: null,
  limitReached2: null,
};

export default withStyles(styles)(NewWorkRequestButton);
